@import "../../scss";

.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: var(--spacer-4);
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  will-change: opacity;
  transition: opacity 0.3s ease-in-out;
  align-items: baseline;

  @include media-breakpoint-down("md") {
    padding: var(--spacer-2);
    align-items: baseline;
  }
}

.root--hidden {
  opacity: 0;
}

.root--hidden * {
  pointer-events: none !important;
}

.buttons {
  display: flex;
  align-items: center;
  pointer-events: all;
  align-self: flex-start;
  transition: opacity 0.3s ease-in-out;
  will-change: opacity;
}

.buttons > *:not(:last-child) {
  margin-right: 0.625rem;
}

.buttons--hidden {
  opacity: 0;
  pointer-events: none;
}

.buttons--hidden * {
  pointer-events: none !important;
}

.logo {
  display: block;
  width: 5.3rem;
  height: auto;
  pointer-events: bounding-box;

  @include media-breakpoint-down("md") {
    width: 3.75rem;
  }
}

.more-icon {
  width: 1.4rem;
  height: auto;

  @include media-breakpoint-down("md") {
    width: 1rem;
  }
}

.future-nature--is-visible {
  opacity: 1;
}
